export const zorgleuvenTheme = {
  primaryColorDarker: '#1b183c',
  font: 'https://fonts.googleapis.com/css?family=Open+Sans',
  favicon: 'assets/zorgleuven/zorg-leuven-favicon.ico',
  logo: 'assets/zorgleuven/zorg-leuven-logo.svg',
  iconFont: 'assets/zorgleuven/icons/Flaticon.css',
};
